/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

//localizations 
document.addEventListener('DOMContentLoaded', function(event) {

  
  var infoBtns = document.querySelectorAll('.info-btn');
  
  var overlay = document.querySelector('.overlay');
  if(infoBtns){
    infoBtns.forEach(function(infoBtn){
          infoBtn.addEventListener('click', function(e) {
          var infoText = e.currentTarget.parentNode.querySelector(".info-text")
      e.preventDefault();
      if (infoText.style.display === 'none') {
        infoText.style.display = 'block';
        overlay.style.display = 'block';
      } else {
        infoText.style.display = 'none';
        overlay.style.display = 'none';
      }
    });

  		overlay.addEventListener('click', function(){

  		overlay.style.display = 'none';
        document.querySelectorAll(".info-text").forEach(elem => {
          elem.style.display = 'none';          
        });

  });

    });

  }
  var openNewsletterBanner = document.querySelector("#openNewsletterBanner");
 console.log(openNewsletterBanner);
 if(openNewsletterBanner && false){
  openNewsletterBanner.addEventListener("click", function(e){
    e.preventDefault();
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', 'UwWUuW']);
  })
 }
  
  
  var upsellProducts = document.querySelectorAll('[name="upsell_product"]');
  upsellProducts.forEach((checkbox) => {
    checkbox.addEventListener("click", function (e) {
      const value = e.target.value;
      console.log("value: ", e.target.dataset)
      document.querySelector(".upsell-name").innerHTML = e.target.dataset.titel;
      document.querySelector(".upsell-desc .new-price").innerHTML = e.target.dataset.price;
      document.querySelector(".upsell-desc .old-price").innerHTML = e.target.dataset.totalPrice;
      document.querySelector(".upsell-image img").src = e.target.dataset.image;
      document.querySelector("#addUpsell").dataset.upsellProductId = e.target.dataset.variantId;
    });
  })
  
  var cartWrapper = document.querySelector("[data-section-type='cart']");
  if(cartWrapper){
    const observerOptions = {
      childList: true,
      attributes: false,

      // Omit (or set to false) to observe only changes to the parent node
      subtree: true
    }

    const observer = new MutationObserver(function(mutations){
      
       console.log("change", mutations);
      if(mutations.find(mutation => mutation.target.classList.contains("PageContent"))){
      	//setTimeout(initCountdown, 500);
        var upsellButtons = document.querySelectorAll(".Button-Upsell");
        if(upsellButtons){
          upsellButtons.forEach(function(upsellButton){
            upsellButton.addEventListener("click", function(e){
              e.preventDefault();
              document.dispatchEvent(new CustomEvent('theme:loading:start')); // Then we add the product in Ajax
              var formElement = {
                items: [
                  {
                   id: e.currentTarget.dataset.variation,
                   quantity: 1
                  }
                ]
              };
              fetch("".concat(window.routes.cartAddUrl, ".js"), {
                    body: JSON.stringify(formElement),
                    credentials: 'same-origin',
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/json',
                      'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
          
                    }
                  }).then(function (response) {
                    window.location.reload();    
                  });
    
            })
          });
        }
      }
    });
    observer.observe(cartWrapper, observerOptions);
  }
   var gridWrapper = document.querySelector(".Grid-Wrapper");
   if(gridWrapper){
  	var flickityInstance = new Flickity(gridWrapper, {
      "prevNextButtons": false,
      "pageDots": true,
      "wrapAround": true,
      "contain": false,
      "groupCells": true,
      "autoPlay": true,
      "adaptiveHeight": false,
      "pauseAutoPlayOnHover": false 
    });
   }
  
  
  var langs = document.querySelectorAll(".lang-menu a.noRedirect");
  langs.forEach((element) => {
    console.log(element);
    element.addEventListener("click", function(e){
 		e.preventDefault();
      document.querySelector("#localization_form [name='country_code']").value = e.currentTarget.dataset.country;
      document.querySelector("#localization_form").submit();
    });
  });
  //read active localizations from shopify -
//event listener for click on country dropdown menu list "li" elements with jQuery
  const announcementHeading = document.querySelector(".AnnouncementHeading_3 ");
  if(announcementHeading){
    var flickityInstanceAdvantagesCarousel = new window.Flickity(
      announcementHeading,
      JSON.parse(announcementHeading.dataset.flickityConfig)
    )
  }
  
  var acc = document.getElementsByClassName("accordion");
  if(acc){
    var i;
    for (i = 0; i < acc.length; i++) {
      acc[i].addEventListener("click", function(e) {
        e.preventDefault();
        this.classList.toggle("active");
        var panel = this.nextElementSibling;
        if (panel.style.maxHeight) {
          panel.style.maxHeight = null;
        } else {
          panel.style.maxHeight = panel.scrollHeight + "px";
        }
      });
    }
  }
  
  
  
 
  
  var applyVoucherButton = document.querySelector("#applyVoucher");
  if(applyVoucherButton){
    applyVoucherButton.addEventListener('click', function(e){
    	e.preventDefault();
      	localStorage.setItem('voucherApplied', JSON.stringify({ value : true, timestamp: new Date().getTime() }));
      	window.location.href = e.target.href;
    });
  }
  
  var DisocuntBannerWrapper = document.querySelector(".Discount-Banner");
  if(DisocuntBannerWrapper){
    
     var countDownTarget = Date.parse(DisocuntBannerWrapper.dataset.discountUntil)

  function showClock(target) {
     var delta = (target - new Date().getTime()) / 1000;
     if(delta < 0){
		DisocuntBannerWrapper.style.display = 'none';
       return;
     }
          // calculate (and subtract) whole days
      var days = Math.floor(delta / 86400);
      delta -= days * 86400;

      // calculate (and subtract) whole hours
      var hours = Math.floor(delta / 3600) % 24;
      delta -= hours * 3600;

      // calculate (and subtract) whole minutes
      var minutes = Math.floor(delta / 60) % 60;
      delta -= minutes * 60;

      // what's left is seconds
      var seconds = Math.floor(delta % 60);  // in theory the modulus is not required
    

      // Output the results
      document.querySelector("#hours").innerHTML = (days*24)+hours;
      document.querySelector("#minutes").innerHTML = minutes;
      document.querySelector("#seconds").innerHTML = seconds;
  }

  showClock(countDownTarget);

  // Update the count down every 1 second
  var x = setInterval(function() {
      showClock(countDownTarget);
      if (countDownTarget - new Date().getTime() < 0) {
          clearInterval(x);
      }
  }, 1000);
    
    
  	var voucherApplied = JSON.parse(localStorage.getItem('voucherApplied'));
    if(voucherApplied){
    var now = new Date().getTime();
    var diff = ((now - voucherApplied.timestamp)/1000)
    if(diff > 60*60*48){
    	voucherApplied = null;
      	localStorage.removeItem('voucherApplied')
    }
    console.log(diff);
    }
    if(voucherApplied && voucherApplied.value){
    	DisocuntBannerWrapper.classList.add("show-success");
    }
  }
  
  

function initCountdown(){  
  var deliveryDay = document.querySelector('.delivery-date');
  if(deliveryDay){
    var local 	   = deliveryDay.dataset.local;
    var timeFormat = deliveryDay.dataset.timeFormat;
    var date = new Date();
    var hours = date.getHours();


    // Samstag
    if (date.getDay() == 6) {
        var newDateMill = date.setDate(date.getDate() + 3);
        var newDate = new Date(newDateMill);
        var displayDay = newDate.toLocaleString(local, { day: "numeric" });
        var displayWeekday = newDate.toLocaleString(local, { weekday: "long" });
        var displayMonth = newDate.toLocaleString(local, { month: "long" });
        deliveryDay.innerHTML = (displayWeekday + ', ' + displayDay + '. ' + displayMonth);
    }

    // Sonntag
    else if (date.getDay() == 0) {
        var newDateMill = date.setDate(date.getDate() + 2);
        var newDate = new Date(newDateMill);
        var displayDay = newDate.toLocaleString(local, { day: "numeric" });
        var displayWeekday = newDate.toLocaleString(local, { weekday: "long" });
        var displayMonth = newDate.toLocaleString(local, { month: "long" });
        deliveryDay.innerHTML = (displayWeekday + ', ' + displayDay + '. ' + displayMonth);
    }

    // Freitag
    else if (date.getDay() == 5) {
       var newDateMill = date.setDate(date.getDate() + 3);
       var newDate = new Date(newDateMill);
       var displayDay = newDate.toLocaleString(local, { day: "numeric" });
       var displayWeekday = newDate.toLocaleString(local, { weekday: "long" });
       var displayMonth = newDate.toLocaleString(local, { month: "long" });
       deliveryDay.innerHTML = (displayWeekday + ', ' + displayDay + '. ' + displayMonth);
    }
	 else if (date.getDay() == 4 && hours >= 13) {
       var newDateMill = date.setDate(date.getDate() + 4);
       var newDate = new Date(newDateMill);
       var displayDay = newDate.toLocaleString(local, { day: "numeric" });
       var displayWeekday = newDate.toLocaleString(local, { weekday: "long" });
       var displayMonth = newDate.toLocaleString(local, { month: "long" });
       deliveryDay.innerHTML = (displayWeekday + ', ' + displayDay + '. ' + displayMonth);
    }

    
    // Montag - Donnerstag
    else {
        if (hours < 13) {
            var newDateMill = date.setDate(date.getDate() + 2);
            var newDate = new Date(newDateMill);
            var displayDay = newDate.toLocaleString(local, { day: "numeric" });
            var displayWeekday = newDate.toLocaleString(local, { weekday: "long" });
            var displayMonth = newDate.toLocaleString(local, { month: "long" });
            deliveryDay.innerHTML = (displayWeekday + ', ' + displayDay + '. ' + displayMonth);
        } else {
            var newDateMill = date.setDate(date.getDate() + 3);
            var newDate = new Date(newDateMill);
            var displayDay = newDate.toLocaleString(local, { day: "numeric" });
            var displayWeekday = newDate.toLocaleString(local, { weekday: "long" });
            var displayMonth = newDate.toLocaleString(local, { month: "long" });
            deliveryDay.innerHTML = (displayWeekday + ', ' + displayDay + '. ' + displayMonth);
        }
    }

    // Countdown until 12 o'clock
    var myreset = [12, 00, 00]; // at what time to reset - 19:40:00
    var mycountdown = startCountdown();

    function startCountdown() {
        var enddate = calculateEndDate();
	    tickTock(calculateStartDate(), enddate) 
        return setInterval(function() { tickTock(calculateStartDate(), enddate) }, 60000);
    }

    function calculateStartDate() { //this needs to be edited if using the server time
        return new Date();
    }

    function calculateEndDate() {
        var enddate = new Date();
        enddate.setHours(myreset[0]);
        enddate.setMinutes(myreset[1]);
        enddate.setSeconds(myreset[2]);
        return enddate;
    }

    function tickTock(startdate, enddate) {
        var diff = enddate.getTime() - startdate.getTime();
        d = diff >= 0 ? diff : diff + 24 * 3600 * 1000;
        var h = Math.floor(d / 3600 / 1000);
        var m = Math.floor(d / 60 / 1000) - 60 * h;
        var s = Math.floor(d / 1000) - 3600 * h - 60 * m;
        printCountdown(h, m, s);
    }

    function printCountdown(h, m, s) {
      	var t = timeFormat.replace("{{hour}}", Math.abs(h)).replace("{{min}}", Math.abs(m));
        //var t = h + (' Std. ') + 'und ' + m + (' Min.');
        jQuery('.countdown').html(t);
    }
  }
}
initCountdown();
  
  
  function getWithExpiry(key) {
	const itemStr = localStorage.getItem(key)
	// if the item doesn't exist, return null
	if (!itemStr) {
		return null
	}
	const item = JSON.parse(itemStr)
	const now = new Date()
	// compare the expiry time of the item with the current time
	if (now.getTime() > item.expiry) {
		// If the item is expired, delete the item from storage
		// and return null
		localStorage.removeItem(key)
		return null
	}
	return item.value
}

function setWithExpiry(key, value) {
	const now = new Date()
    const ttl = 60*60*24;

	// `item` is an object which contains the original value
	// as well as the time when it's supposed to expire
	const item = {
		value: value,
		expiry: now.getTime() + ttl,
	}
	localStorage.setItem(key, JSON.stringify(item))
}
  

  var curentInterval = null;
  function startTimer(duration, display) {
      var timer = (getWithExpiry('cartTimer') || duration),
          minutes, seconds;
      curentInterval = setInterval(function() {
          var display = document.querySelector("#cartCountdown") || 1;

          minutes = parseInt(timer / 60, 10);
          seconds = parseInt(timer % 60, 10);

          minutes = minutes < 10 ? "0" + minutes : minutes;
          seconds = seconds < 10 ? "0" + seconds : seconds;

          display.textContent = minutes + ":" + seconds;
          setWithExpiry('cartTimer', timer);
          if (--timer < 0) {
              timer = duration;
              document.querySelector('.cartCountdownAlert').style.display = 'none';
              clearInterval(curentInterval)
          }

      }, 1000);
  }

  var tenMinutes = 60 * 10;
  var display = document.querySelector('#cartCountdown'); 
  var currentValue = getWithExpiry('cartTimer');

  if(display && (currentValue > 0 || currentValue === null)){
    startTimer(tenMinutes, display);
  } else {
    if(document.querySelector('.cartCountdownAlert')){
      document.querySelector('.cartCountdownAlert').style.display = 'none';
    }
  }

var initTimer = function(e){
 var display = document.querySelector('#cartCountdown'); 
  var currentValue = parseInt(getWithExpiry('cartTimer'));
  console.log(currentValue)
  if(!curentInterval && (currentValue > 0 || currentValue === null || isNaN(currentValue))){
    setWithExpiry('cartTimer', tenMinutes);
    startTimer(tenMinutes, display);
  }
  if(currentValue == 0){
   	console.log("VALUE NULL");
   	document.querySelector("#sidebar-cart").classList.add("hideAlert");
  }
};

  document.addEventListener('product:added', initTimer);
  document.addEventListener('product:quantity:change', initTimer)

  
  
})

var deliveryTimeModal = document.querySelector("#showDeliveryTimeModal");
if(deliveryTimeModal){
  deliveryTimeModal.addEventListener("click", function(event){
	document.querySelector("#deliveryTimeModal").setAttribute('aria-hidden', 'false');    
  });
}

var showConsultingModal = document.querySelector("#showConsultingModal");
if(showConsultingModal){
  showConsultingModal.addEventListener("click", function(event){
    document.querySelector("#consultingModal").setAttribute('aria-hidden', 'false');    
  });
}

var nicolausModals = document.querySelectorAll(".openNicolausModal");
Array.from(nicolausModals).forEach(function(element) {
  element.addEventListener('click', function(event){
  	event.preventDefault();
	var voucher = event.currentTarget.dataset.voucher;
    document.querySelector("#nicolausModal .VoucherCode").innerHTML = voucher;
    var discount = event.currentTarget.dataset.discount;
	document.querySelector("#nicolausModal .discount").innerHTML = discount;
    document.querySelector("#nicolausModal").setAttribute('aria-hidden', 'false');    
  });
});

var modalsCloseBtn = document.querySelectorAll(".Custom-Modal .Modal__Close");
modalsCloseBtn.forEach(function(btn){
	btn.addEventListener("click", function(event){
	event.preventDefault();
  	document.querySelector(".VoucherCode").classList.remove("copied");
	document.querySelector(".Custom-Modal[aria-hidden='false']").setAttribute('aria-hidden', 'true');
});

});

var productInfoCarousel = document.querySelector("#productInformationModal .Carousel");
if(productInfoCarousel){
	    var flickityProductInfoCarousel = new window.Flickity(
      productInfoCarousel,
      JSON.parse(productInfoCarousel.dataset.flickityConfig)
    )

}


var voucherCodeBtn = document.querySelector(".VoucherCode");
voucherCodeBtn.addEventListener("click", function(event){
	event.preventDefault();
	
   /* Get the text field */
  var copyText = event.currentTarget;
  copyText.classList.add("copied");
  

   /* Copy the text inside the text field */
  navigator.clipboard.writeText(copyText.outerText);
  
});



var productInformations = document.querySelector("#showProductInformations");
if (productInformations) {
  productInformations.addEventListener("click", function (e) {
    e.preventDefault();
    var url = document.querySelector('[name="upsell_product"]:checked').dataset.url;
    if(!url){
      url = document.querySelector('[name="upsell_product"]:checked').parentNode.querySelectorAll("select option")[1].dataset.url
    }
    const fullurl = new URL(url, location.origin);
    fullurl.searchParams.set("view", "upsell-modal");
    
    fetch(`${fullurl.toString()}`).then((res) => res.text()).then((res) => {
      document.querySelector("#productInformationModal").innerHTML = res;
      var productSlideshow = document.querySelector("#productInformationModal .Product__Slideshow");

      new window.Flickity(
        productSlideshow,
        JSON.parse(productSlideshow.dataset.flickityConfig)
      )

      document.querySelector("#productInformationModal").setAttribute('aria-hidden', 'false');
      document.querySelector("#productInformationModal .Modal__Close").addEventListener("click", (e) => {
        e.preventDefault();
        document.querySelector("#productInformationModal").setAttribute('aria-hidden', 'true');
      });

    });
    
  });
}

var upsellWrappers = document.querySelectorAll(".ProductForm__AddToCartUpsell");
if(upsellWrappers){
  upsellWrappers.forEach(upsellWrapper => {
  upsellWrapper.addEventListener("click", function(e){    
    e.preventDefault();
    e.stopPropagation();
    var productData = e.currentTarget.dataset;
    var productName = document.querySelector(".upsell-wrapper .upsell-title").innerText;
    var productPrice = document.querySelector(".upsell-wrapper .new-price").innerText;
    
    window.dataLayer.push({
      'event': 'upsellATC',
      'upselledItem': productName,
      'upselledPrice': productPrice
	});

    
    document.dispatchEvent(new CustomEvent('theme:loading:start')); // Then we add the product in Ajax
    var formElement = {
      items: [
        {
         id: productData.productId,
         quantity: 1
        },
        {
         id: productData.upsellProductId,
         quantity: 1
        }
      ]
    };
    fetch("".concat(window.routes.cartAddUrl, ".js"), {
          body: JSON.stringify(formElement),
          credentials: 'same-origin',
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header

          }
        }).then(function (response) {
          document.dispatchEvent(new CustomEvent('theme:loading:end'));
          
          window.location.replace("/cart");

          /**
            document.dispatchEvent(new CustomEvent('product:added', {
              bubbles: true,
              detail: {
                variant: productData.productId,
                quantity: 1
              }
            }));
          */
        });

  });
    });
}